<template lang="pug">
  .form-test-question
    ui-field(label="Вопрос" v-model="value.title" :error="errors.name" rules="required")
    ui-field(type="textarea" label="Описание" v-model="value.description" :error="errors.description" rules="")

    //- b-field(label="Тип ответов")
      b-select(v-model="value.type" :disabled="!value.$isNew")
        option(value="choice") Выбор
        option(value="image") Картинки
        option(value="input") Пользовательский ответ
        option(value="arbitrary") Свободный ответ

    b-field(v-if="value.hasChoice()" label="Тип вариантов ответа")
      b-switch(v-model="value.multiple" :true-value="1" :false-value="0")
        | Можно выбрать несколько вариантов ответа
    
    b-field
      b-switch(v-model="value.free_answer" :true-value="1" :false-value="0")
        | Разрешен свободный ответ

    //- Варианты ответа
    div(v-if="value.type !== 'arbitrary'")
      .panel.is-beige
        .panel-heading Варианты ответов
        .panel-content.has-background-light(v-if="value.id")

          //- label.label Варианты ответов
          //- .box.has-background-light()
          b-field(v-for="answer in value.answers.items" :key="answer.id")
            //- Правильный вариант ответа
            .control(v-if="value.hasChoice()")
              span.button(:class="{'is-success': answer.is_true}" @click="toggleTrueAnswer(answer)")
                b-icon(icon='check').is-marginless

            //- Вопрос
            b-input(v-if="['choice', 'input'].includes(value.type)" v-model="answer.title" ref="answers" expanded)
            div(v-else-if="value.type === 'image'")
              img(v-if="answer.image" :src="answerImagePreview(answer.image)")
              b-upload(v-else v-model="answer.image")
                a.button.is-primary
                  b-icon(icon="upload")
                  span Выбрать файл

            //- Удаление
            .control(v-if="answer.id")
              b-checkbox-button(v-model="selectedAnswers" :native-value="answer.id" type="is-danger")
                b-icon(icon="delete-outline").is-marginless

          //- Удаление выбранных вопросов
          .field.is-grouped.is-pulled-right(v-if="selectedAnswers.length")
            .control: ui-button(@click="unselectAnswers")
              | Отмена
            .control: ui-button.is-danger(@click="deleteAnswers" icon='delete')
              | Удалить выбранное

          ui-button.is-success(@click="newAnswer" icon="plus-circle")
            | Добавить вариант ответа

</template>

<script>
export default {
  name: 'form-test-question',

  props: {
    value: null,
    errors: { type: Object, default: () => ({}) },
  },

  data: () => ({
    selectedAnswers: [],
  }),

  computed: {
    answers() {
      return this.value.answers;
    },
    answersChanged() {
      return this.answers.$isChanged;
    },
    isMultiple() {
      return this.value.multiple;
    },
  },

  watch: {
    answersChanged(hasChanges) {
      this.value.hasChanges = hasChanges;
    },

    isMultiple(isMultiple) {
      if (!isMultiple) {
        const firsChecked = this.answers.find('is_true', 1);
        if (firsChecked) {
          this.toggleTrueAnswer(firsChecked);
        }
      }
    },
  },

  methods: {
    toggleTrueAnswer(answer) {
      if (this.isMultiple) {
        answer.is_true = answer.is_true ? 0 : 1;
      } else {
        this.answers.items.forEach(answer => {
          answer.is_true = 0;
        });
        answer.is_true = answer.is_true ? 0 : 1;
      }
    },

    deleteAnswers() {
      this.selectedAnswers.forEach(id => {
        this.answers.$delete(id);
      });
      this.unselectAnswers();
    },

    unselectAnswers() {
      this.selectedAnswers = [];
    },

    newAnswer() {
      if (this.value.id) {
        this.answers.add({
          test_question_id: this.value.id,
          is_true: this.answers.count() === 0 ? 1 : 0, // Первый элемент всегда выбран
        });

        this.$nextTick(() => {
          const $answers = this.$refs.answers;
          if ($answers && $answers.length) {
            $answers[$answers.length - 1].focus();
          }
        });
      }
    },

    answerImagePreview(image) {
      if (typeof image === 'string') {
        return image;
      }

      if (image instanceof File) {
        return URL.createObjectURL(image);
      }

      return '';
    },
  },
};
</script>
